import { render, staticRenderFns } from "./TP3.vue?vue&type=template&id=445130a6&scoped=true"
import script from "./TP3.vue?vue&type=script&lang=js"
export * from "./TP3.vue?vue&type=script&lang=js"
import style0 from "./TP3.vue?vue&type=style&index=0&id=445130a6&prod&lang=css"
import style1 from "./TP3.vue?vue&type=style&index=1&id=445130a6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "445130a6",
  null
  
)

export default component.exports